var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagnosis02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 295,
    height: 180,
    viewBox: "0 0 295 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img",
    transform: "translate(-40 -1050)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "base",
    width: 295,
    height: 179,
    transform: "translate(40 1051)",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "advice2",
    transform: "translate(92.648 1049.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2039",
    "data-name": "\\u30D1\\u30B9 2039",
    d: "M60.835,79.23c6.134-5.466,15.766-6.576,24.531-6.146,27.535,1.369,52.389,14.659,73.887,29.693,7.783,5.442,15.446,11.306,20.5,18.8,10.283,15.259,7.234,36.394-7.067,48.962-4.865,4.277-10.762,7.557-16.819,10.462-10.762,5.167-22.383,9.314-34.6,10.5a113.974,113.974,0,0,1-26.2-1.019c-24.2-3.282-47.96-10.539-67.872-22.956-8.733-5.446-16.966-12.216-20.565-21.026s-1.3-19.975,7.621-25.19c3.689-2.156,8.1-3.13,12.416-4.045,6.356-1.347,12.813-2.675,18.547-5.411,5.923-2.828,12.938-8.3,11.758-14.547C55.717,90.587,54.706,84.69,60.835,79.23Z",
    transform: "translate(-1.473 -23.541)",
    fill: "#0d71e8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2040",
    "data-name": "\\u30D1\\u30B9 2040",
    d: "M109.206,260.859c13.157,0,23.823-1.889,23.823-4.218s-10.666-4.218-23.823-4.218-23.824,1.888-23.824,4.218S96.049,260.859,109.206,260.859Z",
    transform: "translate(-27.032 -80.388)",
    fill: "#0d71e8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2041",
    "data-name": "\\u30D1\\u30B9 2041",
    d: "M208.28,258.805c6.688,0,12.109-1.194,12.109-2.667s-5.422-2.667-12.109-2.667-12.108,1.194-12.108,2.667S201.593,258.805,208.28,258.805Z",
    transform: "translate(-62.257 -80.72)",
    fill: "#0d71e8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2042",
    "data-name": "\\u30D1\\u30B9 2042",
    d: "M124.26,189.96l-.987-.293.046.717,2.209.844-.4-1.189Z",
    transform: "translate(-39.045 -60.349)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2043",
    "data-name": "\\u30D1\\u30B9 2043",
    d: "M124.26,189.96l-.987-.293.046.717,2.209.844-.4-1.189Z",
    transform: "translate(-39.045 -60.349)",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2044",
    "data-name": "\\u30D1\\u30B9 2044",
    d: "M155.7,222.032a45.414,45.414,0,0,0,13.1-31.977v-.386H123.34Z",
    transform: "translate(-39.097 -60.506)",
    fill: "#c70000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2045",
    "data-name": "\\u30D1\\u30B9 2045",
    d: "M155.7,222.032a45.414,45.414,0,0,0,13.1-31.977v-.386H123.34Z",
    transform: "translate(-39.097 -60.506)",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2046",
    "data-name": "\\u30D1\\u30B9 2046",
    d: "M155.7,223.08A45.414,45.414,0,0,0,168.8,191.1v-.386H123.34Z",
    transform: "translate(-39.097 -60.838)",
    fill: "#c70000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2047",
    "data-name": "\\u30D1\\u30B9 2047",
    d: "M155.7,223.08A45.414,45.414,0,0,0,168.8,191.1v-.386H123.34Z",
    transform: "translate(-39.097 -60.838)",
    fill: "#fff",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2048",
    "data-name": "\\u30D1\\u30B9 2048",
    d: "M208.4,162.1l-.7-6.332a78.994,78.994,0,0,1-1.452-8.551c-.181-2.85-1.554-3.059-1.565-3.059a9.431,9.431,0,0,1-1.844-1.32,5.714,5.714,0,0,0-1.483-1.028l-.208-.111s-.528-2.2-1.158-1.887l-.051-.149a5.509,5.509,0,0,1-.3-1.469v-.184a5.232,5.232,0,0,0,1.6-3.458v-.191c.309-.217.361-.675.442-1.058.151-.7.545-1.329.732-2.022.016-.059.029-.12.04-.182v-.04a2.271,2.271,0,0,0,.037-.385v-.027a1.492,1.492,0,0,0-.592-1.313,1.292,1.292,0,0,1-.276-.193.824.824,0,0,1-.141-.255l-.32-.762a.792.792,0,0,0-.16-.271,1.166,1.166,0,0,0-.428-.2,2.147,2.147,0,0,1-1.037-1.077,4.864,4.864,0,0,0-.818-1.281,3.832,3.832,0,0,0-2.3-.779,2.475,2.475,0,0,0-.057.784,6.118,6.118,0,0,0-3.923.016.907.907,0,0,0-.48.465.569.569,0,0,0-.019.075.465.465,0,0,0,0,.1.864.864,0,0,1,.02.213.32.32,0,0,1-.074.132.326.326,0,0,1-.126.083c-.394.175-.87-.051-1.282.088a1.282,1.282,0,0,0-.7.9,2.968,2.968,0,0,1-.447,1.086c-.128.161-.3.268-.429.417a1.28,1.28,0,0,0-.3,1.019.2.2,0,0,0,0,.029.565.565,0,0,0,.031.144,1.345,1.345,0,0,0,.061.161c.023.046.046.092.072.136a3.115,3.115,0,0,1,.514.909v.012c.079.441-.2.861-.272,1.3,0,.035-.01.069-.012.1v.118c.024.641.612,1.065.961,1.536a2.877,2.877,0,0,0,.452.624c.01.069.021.136.036.2a5.242,5.242,0,0,0,.522,1.489,5.445,5.445,0,0,0,2.8,2.5c0,.063.013.126.019.191,0,.119.016.24.016.359v.174l-.053-.407a1.6,1.6,0,0,0-.6-.008,46.186,46.186,0,0,0-31.682-12.583v22.12c-1.323-.4-2.4-.442-2.323.494.074.961,1.121,1.935,2.323,2.74v21h23.105a3.34,3.34,0,0,0,.161,1.133,22.162,22.162,0,0,1,.225,3.909s.122.661.152.779.393,3.182.393,3.33a11.3,11.3,0,0,1,.3,1.621,7.628,7.628,0,0,0,.544,1.8l.089,2.522s.937,1.411,1,1.5.031,1.86,1.058,2.7a1.192,1.192,0,0,1,.333.568c.077.3,2.656,4.636,3.454,5.972l-.1.454-.641,3-.03,1.26a3.926,3.926,0,0,0-.273,1.53,1.639,1.639,0,0,1,.061.721s-.423.659-.15,1.079.12.66-.273,1.74a.755.755,0,0,0,.2.94,1.267,1.267,0,0,1-.02.161c-.056.48-.118,1.03-.118,1.176s-.056.8-.059,1.377c0,.456.029.867.151.934.272.149,1.784.32,1.813.84s.605,1.259,1.813,1.259,3.295-.419,3.808-.361c.085.012.135-.044.16-.144a.4.4,0,0,0,.012-.051,1.139,1.139,0,0,0,.7.376c1.814.332,4.019-.48,4.444-1.289a1.5,1.5,0,0,0,.122-.32,3.9,3.9,0,0,0-.122-1.809,3.066,3.066,0,0,1-.038-1.239,1.054,1.054,0,0,1,.248-.5,5.437,5.437,0,0,0,.759-1.813c.146-.524.239-.95.239-.95s-.191-.292-.481-.692a7.678,7.678,0,0,0-2.177-2.3.688.688,0,0,1-.064-.189,6.08,6.08,0,0,0-.665-1.282,17.509,17.509,0,0,1-.876-1.53c0-.118-1.208-1.951-1.208-1.951s-.465-1.008-.771-1.554c.036-.1.071-.218.108-.362a24.665,24.665,0,0,0,.572-4.535,1.98,1.98,0,0,1,.3-1.681,3.594,3.594,0,0,0,.425-1.8,19.63,19.63,0,0,1,.3-4.082,56.555,56.555,0,0,0,1.24-6.332,4.521,4.521,0,0,1,.24-.876l.056-2.177v-.133a10.254,10.254,0,0,1,.481-2.311,1.016,1.016,0,0,0,.083-.412h4.986c0-.3-.011-.6-.019-.9h.019a45.924,45.924,0,0,0-.48-6.274c.467-.567,1.033-.961,1.051-1.083a6.635,6.635,0,0,1,.331-1.081A4.783,4.783,0,0,0,208.4,162.1ZM198.335,209.06s.128-.077.337-.184l.038.161a7.5,7.5,0,0,1,.26,1.762c-.063.63-.161,1.621-.161,1.621a5.237,5.237,0,0,0-.383,1.122c-.1-.4-.191-.708-.191-.708s-2.057-1.377-2.057-2.069a5.4,5.4,0,0,0-.141-1.03c-.018-.087-.037-.17-.056-.251a1.817,1.817,0,0,1,.227.354s.613-1.488.76-2.082a.478.478,0,0,0,.026-.227,1.942,1.942,0,0,1-.037-.616c.144.161.255.32.218.436C197.094,207.62,198.335,209.06,198.335,209.06Z",
    transform: "translate(-50.522 -39.864)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2049",
    "data-name": "\\u30D1\\u30B9 2049",
    d: "M213.287,254.285c-.506-.059-2.563.357-3.758.357s-1.762-.743-1.789-1.252-1.521-.685-1.789-.833c-.119-.067-.15-.48-.148-.929,0-.572.057-1.219.057-1.369s.061-.692.117-1.168c.048-.411.093-.769.093-.769,1.4-1.7,4.594-.449,4.594-.449s.137.473.247,1a5.436,5.436,0,0,1,.139,1.023c0,.687,2.03,2.058,2.03,2.058a13.6,13.6,0,0,1,.337,1.414C213.5,253.875,213.512,254.312,213.287,254.285Z",
    transform: "translate(-65.265 -78.806)",
    fill: "#53517c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2050",
    "data-name": "\\u30D1\\u30B9 2050",
    d: "M213.287,256.23c-.506-.058-2.563.359-3.757.359s-1.762-.745-1.789-1.253-1.522-.685-1.791-.834c-.119-.066-.15-.481-.148-.928a4.665,4.665,0,0,1,1.64.75c.447.48.566,1.012.865,1.073a2.472,2.472,0,0,0,2.026.118,12.631,12.631,0,0,1,3.082-.2C213.5,255.822,213.512,256.258,213.287,256.23Z",
    transform: "translate(-65.265 -80.753)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2051",
    "data-name": "\\u30D1\\u30B9 2051",
    d: "M222.177,247.55c-.506.536-.207,1.728-.207,1.728a3.392,3.392,0,0,1,0,2.119c-.416.806-2.595,1.6-4.384,1.282a1.056,1.056,0,0,1-.814-.557c-.437-.861.306-2.366.306-2.366s.09-.984.151-1.61a7.684,7.684,0,0,0-.256-1.754c-.088-.378-.161-.662-.161-.662s2.723-3.907,3.55-3.936a.372.372,0,0,1,.117.013c.6.148,1.62,1.47,2.214,2.308.284.4.473.69.473.69A9.324,9.324,0,0,1,222.177,247.55Z",
    transform: "translate(-68.741 -77.02)",
    fill: "#53517c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2052",
    "data-name": "\\u30D1\\u30B9 2052",
    d: "M222.243,248.626c-.506.536-.206,1.728-.206,1.728a3.393,3.393,0,0,1,0,2.118c-.417.8-2.6,1.611-4.385,1.281a1.056,1.056,0,0,1-.814-.555c.516-.109,1.328-.249,2.6-.4,3.071-.359,2.265-2.385,2.265-2.385a3.546,3.546,0,0,1,.089-2.149,15.842,15.842,0,0,0,.961-3.076c.285.4.473.689.473.689A9.3,9.3,0,0,1,222.243,248.626Z",
    transform: "translate(-68.805 -78.097)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2053",
    "data-name": "\\u30D1\\u30B9 2053",
    d: "M210.995,248.874c-.428-.585-1.694-1.711-4.245.49a1.439,1.439,0,0,1-.689-.274c.048-.411.093-.769.093-.769,1.4-1.7,4.594-.449,4.594-.449S210.884,248.345,210.995,248.874Z",
    transform: "translate(-65.344 -78.806)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2054",
    "data-name": "\\u30D1\\u30B9 2054",
    d: "M216.745,198.833v.131l-.061,2.167a4.368,4.368,0,0,0-.238.866,55.65,55.65,0,0,1-1.224,6.292,19.518,19.518,0,0,0-.3,4.057,3.691,3.691,0,0,1-.419,1.789,2.015,2.015,0,0,0-.292,1.677,24.178,24.178,0,0,1-.564,4.508,1.558,1.558,0,0,1-.212.562.443.443,0,0,0-.072.137c-.429,1.107-1.538,7.944-1.538,7.944s-.011.132-.023.311a3.453,3.453,0,0,0,.023.942.49.49,0,0,1-.025.226c-.144.591-.75,2.071-.75,2.071s-1.163-2.595-4.415.208c0,0-1.253-.12-.864-1.193s.537-1.312.268-1.728.149-1.073.149-1.073a1.639,1.639,0,0,0-.059-.716,3.919,3.919,0,0,1,.269-1.52l.03-1.253.629-2.979.189-.9.2-.928,1.041-18.077.04-.673.292-5.076,7.037-1.163.24,1.847.381.907Z",
    transform: "translate(-65.234 -62.335)",
    fill: "#b3d7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2055",
    "data-name": "\\u30D1\\u30B9 2055",
    d: "M214.131,198.553l-4.311,2.839.161,2.485s.447,4,.447,4.413-.21,3.818-.21,3.818,1.075,1.6.961,2,.922,1.49.922,1.49l1.775,3.4a6.537,6.537,0,0,0,.481,1.316,1.571,1.571,0,0,1-.213.562c-.357.357-1.61,8.082-1.61,8.082s-.011.131-.022.31c-.092-.081-.161-.131-.161-.131a15.22,15.22,0,0,1-.865-1.579,10.562,10.562,0,0,0-.924-1.342l-2.108-4.025-.493-.835.2-.928,1.372-23.826,7.037-1.163.24,1.847-6.407,1.633Z",
    transform: "translate(-65.951 -62.332)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2056",
    "data-name": "\\u30D1\\u30B9 2056",
    d: "M217.692,198.829l-7.872,2.843.292-5.077,7.037-1.163.24,1.847.382.907C217.722,198.553,217.692,198.829,217.692,198.829Z",
    transform: "translate(-66.541 -62.199)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2057",
    "data-name": "\\u30D1\\u30B9 2057",
    d: "M212.451,233.414a.49.49,0,0,1-.025.226.779.779,0,0,1-.161-.4c.09-.269-.716-.9-.716-.9a15.228,15.228,0,0,1-.864-1.58,10.564,10.564,0,0,0-.926-1.342l-2.082-3.963.189-.9.2-.928,1.047-18.069.062,1.527s.452,3.988.452,4.4-.208,3.817-.208,3.817,1.073,1.6.961,2,.924,1.489.924,1.489l1.789,3.4a5.112,5.112,0,0,0,.508,1.342,3.155,3.155,0,0,1,.4.675c-.43,1.107-1.538,7.943-1.538,7.943s-.012.132-.023.311A3.146,3.146,0,0,0,212.451,233.414Z",
    transform: "translate(-65.859 -65.541)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2058",
    "data-name": "\\u30D1\\u30B9 2058",
    d: "M221.4,243.253s-1.342,2.416-2.356,2.476a5.616,5.616,0,0,0-1.985.662c-.088-.378-.16-.662-.16-.662s2.723-3.907,3.55-3.936a.377.377,0,0,1,.117.013v.014A7.189,7.189,0,0,0,221.4,243.253Z",
    transform: "translate(-68.823 -77.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2059",
    "data-name": "\\u30D1\\u30B9 2059",
    d: "M214.988,227.042s-1.342,2.416-2.356,2.476a6.632,6.632,0,0,0-2.355.865s-1.224-1.432-1.135-1.7-.715-.9-.715-.9a15.222,15.222,0,0,1-.865-1.579,10.56,10.56,0,0,0-.926-1.342l-2.116-4.025s-3.548-5.967-3.638-6.325a1.176,1.176,0,0,0-.33-.565c-1.012-.836-.984-2.6-1.043-2.685l-.983-1.491-.09-2.506a7.617,7.617,0,0,1-.536-1.789,11.184,11.184,0,0,0-.3-1.612c0-.15-.357-3.189-.386-3.309s-.15-.775-.15-.775a22.67,22.67,0,0,0-.207-3.878,5.344,5.344,0,0,1-.182-1.738c-.01-.613,0-1.153,0-1.153l17.565-1.82s.109,1,.171,2a6.208,6.208,0,0,1-.051,1.993,10.132,10.132,0,0,0-.481,2.3l-7.932,2.862.088,2.177s.448,4,.448,4.413-.21,3.817-.21,3.817,1.073,1.6.961,2,.923,1.489.923,1.489l1.789,3.4a5.5,5.5,0,0,0,.508,1.342,14.7,14.7,0,0,1,.987,1.882s1.191,1.821,1.191,1.94a17.473,17.473,0,0,0,.865,1.522,6.158,6.158,0,0,1,.655,1.281A7.146,7.146,0,0,0,214.988,227.042Z",
    transform: "translate(-62.374 -60.989)",
    fill: "#b3d7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2060",
    "data-name": "\\u30D1\\u30B9 2060",
    d: "M207.77,221.666s1.461,1.671,2.205,1.7S207.77,221.666,207.77,221.666Z",
    transform: "translate(-65.884 -70.643)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2061",
    "data-name": "\\u30D1\\u30B9 2061",
    d: "M215.932,244.983s4.413-2.267,3.844-1.222a4.509,4.509,0,0,1-2.177,1.6Z",
    transform: "translate(-68.479 -77.556)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2062",
    "data-name": "\\u30D1\\u30B9 2062",
    d: "M207.506,244.936s2.714.178,3.071.626C210.577,245.562,207.685,244.965,207.506,244.936Z",
    transform: "translate(-65.801 -78.016)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2063",
    "data-name": "\\u30D1\\u30B9 2063",
    d: "M207.551,246.289a14.385,14.385,0,0,1,3.281.447A13.472,13.472,0,0,1,207.551,246.289Z",
    transform: "translate(-65.816 -78.445)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2064",
    "data-name": "\\u30D1\\u30B9 2064",
    d: "M168.068,167.191l-.785-.359-1.243-.567s-5.9-2.357-6.088-4.712,6.888,1.551,6.888,1.551a6.756,6.756,0,0,0,.655.881,1.353,1.353,0,0,0,.687.49C168.728,164.535,168.068,167.191,168.068,167.191Z",
    transform: "translate(-50.699 -51.15)",
    fill: "#c37871"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2065",
    "data-name": "\\u30D1\\u30B9 2065",
    d: "M216.279,148.892l-1.938,2.242-4.711-1.549-1.163-.926.743-.984a2.252,2.252,0,0,0,.32-1.378,2.633,2.633,0,0,0-.016-.359,9.151,9.151,0,0,0-.333-1.752s6.709-1.7,6.231-.3a2.486,2.486,0,0,0-.112.9,5.443,5.443,0,0,0,.293,1.461,8.553,8.553,0,0,0,.5,1.216Z",
    transform: "translate(-66.111 -45.581)",
    fill: "#c37871"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2066",
    "data-name": "\\u30D1\\u30B9 2066",
    d: "M215.749,143.872a2.491,2.491,0,0,0-.112.9,5.368,5.368,0,0,1-5.786,1.15,9.15,9.15,0,0,0-.333-1.752S216.227,142.476,215.749,143.872Z",
    transform: "translate(-66.443 -45.568)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2067",
    "data-name": "\\u30D1\\u30B9 2067",
    d: "M215.841,137.106a3.389,3.389,0,0,1-.014.383,5.368,5.368,0,0,1-10.112,2.107,5.269,5.269,0,0,1-.514-1.48,5.052,5.052,0,0,1-.1-1.009,5.367,5.367,0,0,1,10.731-.184C215.839,136.983,215.841,137.045,215.841,137.106Z",
    transform: "translate(-65.046 -41.886)",
    fill: "#c37871"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2068",
    "data-name": "\\u30D1\\u30B9 2068",
    d: "M216.279,150.246l-1.938,2.243-4.711-1.549-1.163-.926.743-.984a2.25,2.25,0,0,0,.32-1.377l.215,1.645.051.051.307.307h.388l.746,1.015s1.073-.864,1.163-.657,1.55-.357,1.55-.357h.056c1.323-.056,1.554-2.026,1.554-2.026a.251.251,0,0,1,.032-.024,8.619,8.619,0,0,0,.5,1.216Z",
    transform: "translate(-66.111 -46.938)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2069",
    "data-name": "\\u30D1\\u30B9 2069",
    d: "M214.416,193.2c-.033.13-.07.256-.111.383-1.163,3.7-9.544,3.787-9.544,3.787l-.238-2.3-.8,1.551a49.771,49.771,0,0,1-7.04-2.456c-.01-.613,0-1.153,0-1.153l17.565-1.82S214.354,192.2,214.416,193.2Z",
    transform: "translate(-62.376 -60.847)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2070",
    "data-name": "\\u30D1\\u30B9 2070",
    d: "M171.471,168.669l-.785-.359a19.879,19.879,0,0,0,.217-2.847,1.355,1.355,0,0,0,.687.49C172.131,166.013,171.471,168.669,171.471,168.669Z",
    transform: "translate(-54.104 -52.632)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2071",
    "data-name": "\\u30D1\\u30B9 2071",
    d: "M206,170.894s1.314,4.713.151,8.411-9.545,3.781-9.545,3.781l-.238-2.3-.8,1.552s-6.262-1.732-7.484-2.746a2.277,2.277,0,0,1-.6-2.535,9.8,9.8,0,0,1,.775-2.386,3.389,3.389,0,0,0,.3-2.083,8.071,8.071,0,0,1,.6-2.476c.179-.3-.031-8.261-.031-8.261a14.126,14.126,0,0,0-2.8,1.551,22.523,22.523,0,0,1-3.281,2.082s-2.953.359-3.489.359-3.491-.359-3.491-.359a2.873,2.873,0,0,1-1.042-.208,3.086,3.086,0,0,0-.777-.328s-.833-.18-1.073-.506a16.03,16.03,0,0,0-2.243-1.432c.387-.239.418-3.364.418-3.364l3.787.924s.24-.506.6-.3a14.2,14.2,0,0,0,2.535.383,7.885,7.885,0,0,1,1.909-.21c.09.147.357.12.357.12s.359-.03.359-.147.32.027.32.027l.6.09s-.089-.774.18-.833a.4.4,0,0,0,.3-.329s.8-1.073,1.193-1.073.657-1.073.657-1.073l1.432-1.461s-.18-.746,0-.777.206-.357.206-.357.061-.655.389-.8.506-1.012.506-1.012a10.473,10.473,0,0,0,1.64-2.3.974.974,0,0,1,.747-.717,3.7,3.7,0,0,1,1.1-.48c.508-.09,1.85-.24,1.85-.24a10.879,10.879,0,0,0,2.685-.48,1.165,1.165,0,0,1,.923-.24.3.3,0,0,0,.16-.059,9.693,9.693,0,0,0,.819-.834,1.221,1.221,0,0,1,.983-.18l.269,2.058.05.05.307.307h.388l.746,1.016s1.073-.866,1.163-.657,1.55-.359,1.55-.359h.056c1.323-.056,1.554-2.025,1.554-2.025.657-.568,1.224,1.82,1.224,1.82l.207.111a5.533,5.533,0,0,1,1.463,1.022,9.619,9.619,0,0,0,1.819,1.31Z",
    transform: "translate(-54.213 -46.897)",
    fill: "#53517c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2072",
    "data-name": "\\u30D1\\u30B9 2072",
    d: "M220.2,191.417l-.881.71-1,.8s-1.85,4.325-4.384,3.1,3.4-5.746,3.4-5.746l.82-.4.909-.439Z",
    transform: "translate(-67.648 -60.292)",
    fill: "#c37871"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2073",
    "data-name": "\\u30D1\\u30B9 2073",
    d: "M209.169,149.937a11.359,11.359,0,0,0-2.083,1.293l-.043-2.386a9.649,9.649,0,0,0,.818-.836,1.255,1.255,0,0,1,.984-.178l.269,2.057Z",
    transform: "translate(-65.653 -46.997)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2074",
    "data-name": "\\u30D1\\u30B9 2074",
    d: "M209.432,149.418a11.37,11.37,0,0,0-2.082,1.293l-.038-2.379a9.817,9.817,0,0,0,.818-.835,1.22,1.22,0,0,1,.983-.179l.269,2.058Z",
    transform: "translate(-65.738 -46.833)",
    fill: "#e6eaed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2075",
    "data-name": "\\u30D1\\u30B9 2075",
    d: "M219.566,150.567c-.458,1.227-1.028,2.585-1.131,2.065-.124-.616-1.2-1.488-1.853-1.97,1.323-.055,1.554-2.025,1.554-2.025.657-.567,1.224,1.82,1.224,1.82Z",
    transform: "translate(-68.724 -47.238)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2076",
    "data-name": "\\u30D1\\u30B9 2076",
    d: "M219.566,149.781c-.458,1.227-1.028,2.586-1.131,2.065-.124-.617-1.2-1.489-1.853-1.97,1.323-.056,1.554-2.025,1.554-2.025.657-.569,1.224,1.819,1.224,1.819Z",
    transform: "translate(-68.724 -46.988)",
    fill: "#e6eaed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2077",
    "data-name": "\\u30D1\\u30B9 2077",
    d: "M212.047,219.586s3.4-.481,3.25.238S212.047,219.586,212.047,219.586Z",
    transform: "translate(-67.244 -69.934)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2078",
    "data-name": "\\u30D1\\u30B9 2078",
    d: "M204.014,202.287a4.127,4.127,0,0,1,2.535-.417Z",
    transform: "translate(-64.692 -64.216)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2079",
    "data-name": "\\u30D1\\u30B9 2079",
    d: "M200.826,199.6a8.015,8.015,0,0,1,2.953.03Z",
    transform: "translate(-63.679 -63.471)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2080",
    "data-name": "\\u30D1\\u30B9 2080",
    d: "M213.757,206.868s-1.879,2-1.762,2.535Z",
    transform: "translate(-67.224 -65.838)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2081",
    "data-name": "\\u30D1\\u30B9 2081",
    d: "M187.724,167.624s-.3,1.073,1.521,1.52Z",
    transform: "translate(-59.51 -53.318)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2082",
    "data-name": "\\u30D1\\u30B9 2082",
    d: "M186.945,170.329s2.243,2,1.193,2.058S186.945,170.329,186.945,170.329Z",
    transform: "translate(-59.269 -54.182)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2083",
    "data-name": "\\u30D1\\u30B9 2083",
    d: "M194.234,158.586s2.744,1.908,2.563,2.357S194.234,158.586,194.234,158.586Z",
    transform: "translate(-61.585 -50.436)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2084",
    "data-name": "\\u30D1\\u30B9 2084",
    d: "M222.449,191.416l-.881.71a5.363,5.363,0,0,0-1.161-2.243l.909-.439Z",
    transform: "translate(-69.935 -60.28)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2085",
    "data-name": "\\u30D1\\u30B9 2085",
    d: "M222.707,154.879l1.194-.745s1.371.208,1.551,3.044a79.236,79.236,0,0,0,1.432,8.5l.686,6.291a4.637,4.637,0,0,1,.03,1.79,6.505,6.505,0,0,0-.32,1.073c-.03.21-1.67,1.224-1.64,2.535s-2.082,2.535-2.082,2.535a8.8,8.8,0,0,0-1.82,1.372s-.508-2.386-1.61-2.983,2.326-5.338,2.326-5.338Z",
    transform: "translate(-69.778 -49.07)",
    fill: "#53517c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2086",
    "data-name": "\\u30D1\\u30B9 2086",
    d: "M219.454,181.8s-3.578,1.491-3.281,1.969S219.454,181.8,219.454,181.8Z",
    transform: "translate(-68.589 -57.84)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2087",
    "data-name": "\\u30D1\\u30B9 2087",
    d: "M220.351,184.59s-1.488.659-1.365.868S220.351,184.59,220.351,184.59Z",
    transform: "translate(-69.483 -58.728)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2088",
    "data-name": "\\u30D1\\u30B9 2088",
    d: "M219.128,186.424s-1.488.659-1.365.868S219.128,186.424,219.128,186.424Z",
    transform: "translate(-69.096 -59.313)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2089",
    "data-name": "\\u30D1\\u30B9 2089",
    d: "M163.318,130.313v45.173h45.467A45.562,45.562,0,0,0,163.318,130.313Z",
    transform: "translate(-51.848 -41.506)",
    fill: "#c70000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2090",
    "data-name": "\\u30D1\\u30B9 2090",
    d: "M163.318,130.313v45.173h45.467A45.562,45.562,0,0,0,163.318,130.313Z",
    transform: "translate(-51.848 -41.506)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2091",
    "data-name": "\\u30D1\\u30B9 2091",
    d: "M163.318,129v45.174h45.467A45.56,45.56,0,0,0,163.318,129Z",
    transform: "translate(-51.848 -41.088)",
    fill: "#c70000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2092",
    "data-name": "\\u30D1\\u30B9 2092",
    d: "M214.563,196.419a1.17,1.17,0,0,1,.212-.692,1.13,1.13,0,0,1,.509-.286c.17-.056.342-.109.513-.16a1.307,1.307,0,0,1,.413-.068,1.451,1.451,0,0,1,.76.356.321.321,0,0,1,.109.113c.051.119-.059.242-.161.32a7.6,7.6,0,0,1-1.139.838,2.3,2.3,0,0,1-1,.344C214.371,197.2,214.536,196.717,214.563,196.419Z",
    transform: "translate(-68.025 -62.119)",
    fill: "#c37871"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2093",
    "data-name": "\\u30D1\\u30B9 2093",
    d: "M215.841,137.1a3.4,3.4,0,0,1-.014.383.748.748,0,0,1-.071.042,2.061,2.061,0,0,0-.264.117c-.262.178-.2.566-.178.88a2.365,2.365,0,0,1-.272,1.312.469.469,0,0,1-.415-.391,3.176,3.176,0,0,1-.025-.614,5.34,5.34,0,0,0-.512-1.552,26.957,26.957,0,0,1-.514-3.1,1.29,1.29,0,0,0-.437-.8,1.172,1.172,0,0,0-1.176.059,6.71,6.71,0,0,1-1.088.59,3.241,3.241,0,0,1-1.866-.227,1.924,1.924,0,0,0-2.908,1.591,1.6,1.6,0,0,0-.085.551c.011.161.074.329.069.5,0,.359-.306.641-.425.98-.074.21-.056.728-.36.724a.19.19,0,0,1-.1-.031,5.051,5.051,0,0,1-.1-1.009,5.367,5.367,0,0,1,10.731-.184C215.839,136.981,215.841,137.044,215.841,137.1Z",
    transform: "translate(-65.046 -41.88)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2094",
    "data-name": "\\u30D1\\u30B9 2094",
    d: "M202.961,133.808c-.019-.517.373-1,.284-1.511-.07-.4-.417-.689-.585-1.057a1.283,1.283,0,0,1,.2-1.351c.131-.148.3-.262.423-.413a3.073,3.073,0,0,0,.441-1.081,1.283,1.283,0,0,1,.693-.895c.4-.138.873.086,1.26-.088a.325.325,0,0,0,.2-.212.748.748,0,0,0-.021-.213c-.027-.285.244-.508.5-.633a6,6,0,0,1,3.871-.016,2.528,2.528,0,0,1,.056-.779,3.773,3.773,0,0,1,2.27.772,4.8,4.8,0,0,1,.8,1.271,2.162,2.162,0,0,0,1.023,1.07,1.137,1.137,0,0,1,.423.2.805.805,0,0,1,.16.269l.308.758a.823.823,0,0,0,.141.255,1.281,1.281,0,0,0,.271.191,1.756,1.756,0,0,1,.5,1.935c-.186.689-.573,1.312-.721,2.011-.086.411-.136.914-.512,1.1a2.176,2.176,0,0,0-.264.118c-.261.176-.2.564-.178.878a2.38,2.38,0,0,1-.271,1.312.469.469,0,0,1-.415-.391,3.184,3.184,0,0,1-.027-.614,5.327,5.327,0,0,0-.512-1.552,26.475,26.475,0,0,1-.512-3.1,1.3,1.3,0,0,0-.441-.8,1.159,1.159,0,0,0-1.176.059,6.39,6.39,0,0,1-1.086.588,3.238,3.238,0,0,1-1.868-.229,1.923,1.923,0,0,0-2.9,1.592,1.623,1.623,0,0,0-.088.551,4.911,4.911,0,0,1,.07.5c0,.361-.306.641-.424.982-.074.21-.056.726-.361.723-.231,0-.465-.522-.578-.674C203.565,134.869,202.985,134.441,202.961,133.808Z",
    transform: "translate(-64.238 -39.917)",
    fill: "#4b3e3c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_732",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 732",
    transform: "translate(138.313 86.896)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2095",
    "data-name": "\\u30D1\\u30B9 2095",
    d: "M203.243,134.254c-.07-.4-.417-.687-.585-1.055a1.215,1.215,0,0,1-.094-.33,1.25,1.25,0,0,0,.094.687c.161.365.5.652.581,1.042A1.022,1.022,0,0,0,203.243,134.254Z",
    transform: "translate(-202.551 -129.131)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2096",
    "data-name": "\\u30D1\\u30B9 2096",
    d: "M207.41,127.423a.152.152,0,0,0,0-.025.369.369,0,0,0-.019.075A.209.209,0,0,0,207.41,127.423Z",
    transform: "translate(-204.084 -127.398)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2097",
    "data-name": "\\u30D1\\u30B9 2097",
    d: "M221.712,134.656c-.184.689-.574,1.313-.721,2.01-.087.413-.137.915-.513,1.1a2.4,2.4,0,0,0-.264.117c-.216.148-.212.439-.191.715a.471.471,0,0,1,.191-.356,2.225,2.225,0,0,1,.264-.118c.376-.188.426-.691.513-1.1.147-.7.536-1.322.721-2.011a2.438,2.438,0,0,0,.08-.828A2.486,2.486,0,0,1,221.712,134.656Z",
    transform: "translate(-208.084 -129.549)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2098",
    "data-name": "\\u30D1\\u30B9 2098",
    d: "M215.462,139.751a.469.469,0,0,1-.415-.391,3.191,3.191,0,0,1-.027-.615,5.312,5.312,0,0,0-.512-1.551,26.5,26.5,0,0,1-.512-3.1,1.293,1.293,0,0,0-.441-.8,1.165,1.165,0,0,0-1.176.059,6.432,6.432,0,0,1-1.086.588,3.237,3.237,0,0,1-1.868-.228,1.923,1.923,0,0,0-2.9,1.591,1.63,1.63,0,0,0-.088.552.712.712,0,0,0,.016.113,2.467,2.467,0,0,1,.072-.306,1.923,1.923,0,0,1,2.9-1.592,3.248,3.248,0,0,0,1.868.229,6.584,6.584,0,0,0,1.086-.588,1.162,1.162,0,0,1,1.176-.059,1.27,1.27,0,0,1,.441.8,27.079,27.079,0,0,0,.512,3.1,5.784,5.784,0,0,1,.512,1.552,3.122,3.122,0,0,0,.027.613.469.469,0,0,0,.415.391,2.39,2.39,0,0,0,.272-1.3A2.406,2.406,0,0,1,215.462,139.751Z",
    transform: "translate(-203.78 -129.222)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2099",
    "data-name": "\\u30D1\\u30B9 2099",
    d: "M205.039,138.65c-.074.21-.056.726-.36.724-.231,0-.465-.521-.579-.673-.32-.434-.842-.833-.937-1.392a1.188,1.188,0,0,0-.014.221c.024.633.6,1.06.952,1.528.114.161.348.673.579.674.3,0,.286-.514.36-.724.119-.34.417-.621.425-.982a1.033,1.033,0,0,0-.023-.2A8.843,8.843,0,0,1,205.039,138.65Z",
    transform: "translate(-202.74 -130.538)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2100",
    "data-name": "\\u30D1\\u30B9 2100",
    d: "M51.927,184.717h-.538v.548h.538Z",
    transform: "translate(-16.17 -58.768)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2101",
    "data-name": "\\u30D1\\u30B9 2101",
    d: "M51.927,184.717h-.538v.548h.538Z",
    transform: "translate(-16.17 -58.768)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2102",
    "data-name": "\\u30D1\\u30B9 2102",
    d: "M118.672,118.673h-.526v.611h.526Z",
    transform: "translate(-37.415 -37.702)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2103",
    "data-name": "\\u30D1\\u30B9 2103",
    d: "M118.672,118.673h-.526v.611h.526Z",
    transform: "translate(-37.415 -37.702)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2104",
    "data-name": "\\u30D1\\u30B9 2104",
    d: "M97.747,164.571V119.4h-.094a45.563,45.563,0,0,0-45.561,45.188Z",
    transform: "translate(-16.448 -38.017)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2105",
    "data-name": "\\u30D1\\u30B9 2105",
    d: "M97.747,164.571V119.4h-.094a45.563,45.563,0,0,0-45.561,45.188Z",
    transform: "translate(-16.448 -38.017)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2106",
    "data-name": "\\u30D1\\u30B9 2106",
    d: "M97.747,164.571V119.4h-.094a45.563,45.563,0,0,0-45.561,45.188Z",
    transform: "translate(-16.448 -38.017)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2107",
    "data-name": "\\u30D1\\u30B9 2107",
    d: "M97.044,163.868V118.694h-.095a45.564,45.564,0,0,0-45.561,45.188Z",
    transform: "translate(-16.224 -37.792)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2108",
    "data-name": "\\u30D1\\u30B9 2108",
    d: "M97.044,163.868V118.694h-.095a45.564,45.564,0,0,0-45.561,45.188Z",
    transform: "translate(-16.224 -37.792)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2109",
    "data-name": "\\u30D1\\u30B9 2109",
    d: "M167.3,238.828l.672.421v.8l-.911-.141Z",
    transform: "translate(-52.952 -76.081)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2110",
    "data-name": "\\u30D1\\u30B9 2110",
    d: "M167.3,238.828l.672.421v.8l-.911-.141Z",
    transform: "translate(-52.952 -76.081)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2111",
    "data-name": "\\u30D1\\u30B9 2111",
    d: "M73.587,239.256l-.252.075v.8l.852-.186-.21-.78Z",
    transform: "translate(-23.182 -76.188)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2112",
    "data-name": "\\u30D1\\u30B9 2112",
    d: "M73.587,239.256l-.252.075v.8l.852-.186-.21-.78Z",
    transform: "translate(-23.182 -76.188)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2113",
    "data-name": "\\u30D1\\u30B9 2113",
    d: "M106.39,193.946,73.336,225.8a45.555,45.555,0,0,0,64.937.026Z",
    transform: "translate(-23.214 -61.861)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2114",
    "data-name": "\\u30D1\\u30B9 2114",
    d: "M106.39,192.773,73.336,224.632a45.553,45.553,0,0,0,64.937.025Z",
    transform: "translate(-23.214 -61.489)",
    fill: "#c70000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2115",
    "data-name": "\\u30D1\\u30B9 2115",
    d: "M106.39,192.773,73.336,224.632a45.553,45.553,0,0,0,64.937.025Z",
    transform: "translate(-23.214 -61.489)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2116",
    "data-name": "\\u30D1\\u30B9 2116",
    d: "M106.39,193.946,73.336,225.8a45.555,45.555,0,0,0,64.937.026Z",
    transform: "translate(-23.214 -61.861)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2117",
    "data-name": "\\u30D1\\u30B9 2117",
    d: "M117.8,191.041l1.1-.753.16.32-1.256.918Z",
    transform: "translate(-37.307 -60.546)",
    fill: "#0a55ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2118",
    "data-name": "\\u30D1\\u30B9 2118",
    d: "M116.353,189.544l1.161-.428.161.32-1.982.667Z",
    transform: "translate(-36.637 -60.172)",
    fill: "#0a55ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2119",
    "data-name": "\\u30D1\\u30B9 2119",
    d: "M116.059,187.659l1.227-.067v.32l-2.061.216.184-.415Z",
    transform: "translate(-36.488 -59.685)",
    fill: "#0a55ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2120",
    "data-name": "\\u30D1\\u30B9 2120",
    d: "M97.153,187.592,52.724,197.71a45.723,45.723,0,0,1-1.043-9.732v-.386Z",
    transform: "translate(-16.317 -59.707)",
    fill: "#0a55ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2121",
    "data-name": "\\u30D1\\u30B9 2121",
    d: "M97.153,188.061,52.724,198.178a45.716,45.716,0,0,1-1.043-9.731v-.386Z",
    transform: "translate(-16.317 -59.857)",
    fill: "#0b60c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2122",
    "data-name": "\\u30D1\\u30B9 2122",
    d: "M53.326,199.23a45.138,45.138,0,0,0,4.633,12.3l39.8-22.412Z",
    transform: "translate(-16.84 -60.227)",
    fill: "#0a55ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2123",
    "data-name": "\\u30D1\\u30B9 2123",
    d: "M53.559,199.7A45.136,45.136,0,0,0,58.191,212l39.8-22.413Z",
    transform: "translate(-16.914 -60.376)",
    fill: "#0b60c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2124",
    "data-name": "\\u30D1\\u30B9 2124",
    d: "M100.862,190.293,61.135,212.67l.019.035a45.557,45.557,0,0,0,7.433,9.946l32.358-32.358Z",
    transform: "translate(-19.32 -60.703)",
    fill: "#0a55ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2125",
    "data-name": "\\u30D1\\u30B9 2125",
    d: "M101.094,190.762,61.367,213.139l.019.036a45.557,45.557,0,0,0,7.433,9.946l32.358-32.358Z",
    transform: "translate(-19.394 -60.852)",
    fill: "#0b60c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2126",
    "data-name": "\\u30D1\\u30B9 2126",
    d: "M10.263,58.237a33.838,33.838,0,1,0,0-47.855A33.838,33.838,0,0,0,10.263,58.237Z",
    transform: "translate(0)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2127",
    "data-name": "\\u30D1\\u30B9 2127",
    d: "M84.721,90.832l-4.65-17.423L68.357,85.881Z",
    transform: "translate(-21.606 -23.28)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2128",
    "data-name": "\\u30D1\\u30B9 2128",
    d: "M44.846,46.976h4.722L50.6,28.825l.246-6.837h-7.28l.246,6.837ZM47.207,60.06a4.729,4.729,0,1,0-4.476-4.722A4.56,4.56,0,0,0,47.207,60.06Z",
    transform: "translate(-13.463 -6.817)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnosis02);
export default __webpack_public_path__ + "static/media/diagnosis02.e3db87773598c523bc08b2993f34343e.svg";
export { ForwardRef as ReactComponent };